(function () {
    'use strict';

    function adminEntityConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/adminEntityConfiguration.html',
            link: function (scope) {
            }
        };
    }

    adminEntityConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('adminEntityConfiguration', adminEntityConfiguration);
})();

